import RefluencedLogoSrc from "@/assets/refluenced_icon.svg";
import {memo, useEffect, type ComponentType} from "react";
import {type FallbackProps} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router";
import {usePrevious} from "react-use";

const ErrorPage: ComponentType<Partial<FallbackProps>> = ({resetErrorBoundary}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const prevLoc = usePrevious(location.pathname);

  useEffect(() => {
    if (prevLoc && prevLoc !== location.pathname) resetErrorBoundary?.();
  }, [location.pathname, prevLoc, resetErrorBoundary]);

  return (
    <div
      style={{minHeight: "50vh"}}
      className={
        "text-neutral-black flex flex-col items-center justify-center gap-2 px-20 " +
        (resetErrorBoundary ? "h-1/2" : "h-screen")
      }>
      <div className="h-48 shrink-0 cursor-pointer pb-6" onClick={() => navigate("/")}>
        <img src={RefluencedLogoSrc} className="size-full object-contain" />
      </div>
      <span className="text-center text-3xl font-medium">{t("unknownError")}</span>
      <span className="text-neutral-grey-dark text-center text-lg font-medium">
        {t("Please try again later. If the problem persists, please contact support")}
      </span>
    </div>
  );
};

export default memo(ErrorPage);
